import React from 'react';
import {
  Avatar,
  createTheme,
  Box,
  CardContent,
  Button,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
  TextField,
  Grid,
  Stack,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  CircularProgress,
  Alert,
  Tooltip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { format } from 'date-fns';
import Client from '../Client';
import Config from '../ClientConfig';
import BackofficeReportsApi from './backofficeReportsApi';

let theme = createTheme();

let d = new Date();
// const getISODay = d => (d.getDay() + 6) % 7 + 1;

let today = format(d, 'yyyy-MM-dd');  // mm=week, MM=month
// let yesterday = format(new Date(new Date(d).setDate(d.getDate() - 1)), 'yyyy-MM-dd');
let d1Month = format(new Date(d.getFullYear(), d.getMonth(), 1), 'yyyy-MM-dd'); //beginning of the month
let dzMonth = format(new Date(d.getFullYear(), d.getMonth() + 1, 0), 'yyyy-MM-dd'); //end of the month
let d1LastMonth = format(new Date(d.getFullYear(), d.getMonth() - 1, 1), 'yyyy-MM-dd');   // first day of last month
let dzLastMonth = format(new Date(d.getFullYear(), d.getMonth(), 0),     'yyyy-MM-dd');   // last day of last month
// let d1Year  = format(new Date(d.getFullYear(), 0, 1), 'yyyy-MM-dd'); //beginning of the year
// let dzYear  = format(new Date(d.getFullYear(), 11, 31), 'yyyy-MM-dd');  //end of the year
// let d1Week = format(new Date(new Date(d).setDate(d.getDate() - getISODay(d) + 1)), 'yyyy-MM-dd'); //beginning of the week
// let dzWeek  = format(new Date(d.getFullYear(), d.getMonth(), d.getDate() + (6 - getISODay(d))), 'yyyy-MM-dd'); //end of the week
// let d1LWeek = format(new Date(d.getFullYear(), d.getMonth(), d.getDate() - getISODay(d) - 7),   'yyyy-MM-dd'); //beginning of last week
// let dzLWeek = format(new Date(d.getFullYear(), d.getMonth(), d.getDate() - getISODay(d) - 1),   'yyyy-MM-dd'); //end of last week

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function thousandsSeparator(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

const objectToCsv = function (data) {
  if (!data || data.length === 0) return '';
  const csvRows = [];
  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(','));
  for (const row of data) {
    const values = headers.map((header) => {
      let val = row[header];
      if (val === null || val === undefined) val = '';
      const s = String(val).replace(/"/g, '""');
      return `"${s}"`;
    });
    csvRows.push(values.join(','));
  }
  return csvRows.join('\n');
};

async function safeClientGet(client, url, params) {
  try {
    const res = await client.getData(url, params);
    return res;
  } catch (e) {
    console.error('GET failed', e);
    return null;
  }
}

async function safeClientPush(client, url, payload) {
  try {
    if (client.pushData) return await client.pushData(url, payload);
  } catch (e) {
    console.error('PUSH failed', e);
  }
  return null;
}

function readExpanded() {
  try {
    const j = localStorage.getItem('salesTargetsExpanded');
    const v = j ? JSON.parse(j) : {};
    return (v && typeof v === 'object') ? v : {};
  } catch {
    return {};
  }
}
function writeExpanded(obj) {
  try { localStorage.setItem('salesTargetsExpanded', JSON.stringify(obj)); } catch {}
}

const API_URL_SALES_TARGETS = Config.API_URL_REPORTS_SALES_TARGET;

class SalesTargetsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: new Client('none'),
      loading: false,
      targets: [],
      // adding new item
      adding: null, // { location, dateFrom, dateTo, valueStr, wDelivery, lockPeriod, lockDelivery }
      addError: null,
      filterFrom: props.dateFrom || d1Month,
      filterTo: props.dateTo || dzMonth,
      submitBusy: false,
      defaultLocation: props.defaultLocation || '',
      locations: [],
      showHeaderCreator: false,
      headerDateFrom: props.dateFrom || d1Month,
      headerDateTo: props.dateTo || dzMonth,
      headerWDelivery: false,
      // inline edit single row
      editingRow: null, // { iref, valueStr, saving, error }
      // keep track of expanded groups so they don't collapse on refresh (and persist)
      expandedKeys: readExpanded(),
      // bulk edit per-group
      bulkMode: {},     // { [label]: true/false }
      bulkFields: {},   // { [label]: { dateFrom, dateTo, wDelivery } }
      bulkErrors: {},   // { [label]: { dateFrom?, dateTo?, range?, empty?, nosel?, conflict? } }
      selected: {},     // { [label]: { [iref]: true } }
      applyError: null,
      saveNotice: null,
    };
  }

  componentDidMount() {
    this.loadLocations();
    this.fetchTargets();
  }

  loadLocations = async () => {
    const resp =
      this.state.client.getData(
        Config.API_URL_LOCATIONS + 'list_locations/',
        { status: 1 }
      ) || {};
    const locations = Array.isArray(resp.locations) ? resp.locations : [];
    locations.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    this.setState({ locations });
  };

  getLocationName = (iref) => {
    const { locations } = this.state;
    const found = locations.find((l) => (l.iref ?? l.id ?? l.code) === iref);
    return found ? found.name : iref;
  };

  async fetchTargets() {
    this.setState({ loading: true, applyError: null, saveNotice: null });
    const { filterFrom, filterTo } = this.state;
    const res = await safeClientGet(this.state.client, API_URL_SALES_TARGETS, {
      dateFrom: filterFrom,
      dateTo: filterTo,
    });
    let targets =
      res && (res.salesTarget || res.result || res)
        ? res.salesTarget || res.result || res
        : [];
    // Keep only total amount + empty/null p* refs
    targets = targets.filter(
      (t) =>
        (t.targetType === 0 || t.targetType === '0') &&
        (t.pCategory === null || t.pCategory === '' || t.pCategory === undefined) &&
        (t.pClass === null || t.pClass === '' || t.pClass === undefined) &&
        (t.pSubCategory === null || t.pSubCategory === '' || t.pSubCategory === undefined)
    );
    this.setState({ targets, loading: false, editingRow: null });
  }

  onDownloadTargets = () => {
    const rows = (this.state.targets || []).map((t) => (
      {
        iref: t.iref,
        location: this.getLocationName(t.location),
        dateFrom: t.dateFrom,
        dateTo: t.dateTo,
        value: thousandsSeparator(t.value),
        wDelivery: t.wDelivery ? 'Yes' : 'No',
      }
    ));
    const link = document.createElement('a');
    link.download = 'sales_targets.csv';
    const csv = "\uFEFF" + objectToCsv(rows);
    link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    link.click();
  };

  parsePeriodLabel = (label) => {
    const parts = label.split('→').map((s) => s.trim());
    return { from: parts[0], to: parts[1] };
  };

  setExpanded = (label, isExp) => {
    this.setState((prev) => {
      const ek = { ...prev.expandedKeys, [label]: isExp };
      writeExpanded(ek);
      return { expandedKeys: ek };
    });
  };

  // Add a new location for an existing period (lock period + delivery)
  addNewForPeriod = (label) => {
    const { from, to } = this.parsePeriodLabel(label);
    const anyRow = (this.state.targets || []).find(t => `${t.dateFrom} → ${t.dateTo}` === label);
    const wDelivery = anyRow ? !!anyRow.wDelivery : false;
    this.setState((prev) => ({
      // ensure the group stays open
      expandedKeys: (() => { const ek = { ...prev.expandedKeys, [label]: true }; writeExpanded(ek); return ek; })(),
      // hide header creator if open
      showHeaderCreator: false,
      // open add panel locked to this period
      adding: {
        location: prev.defaultLocation,
        dateFrom: from,
        dateTo: to,
        valueStr: '',
        wDelivery: wDelivery,
        lockPeriod: true,
        lockDelivery: true,
      },
      addError: null,
    }));
  };

  groupedByPeriod() {
    const groups = {};
    for (const t of this.state.targets) {
      const key = `${t.dateFrom} → ${t.dateTo}`;
      if (!groups[key]) groups[key] = [];
      groups[key].push(t);
    }
    return groups;
  }

  startAddFromHeader = () => {
    this.setState((prev) => ({
      adding: {
        location: prev.defaultLocation,
        dateFrom: prev.headerDateFrom,
        dateTo: prev.headerDateTo,
        valueStr: '',
        wDelivery: prev.headerWDelivery,
        lockPeriod: true,
        lockDelivery: true,
      },
      addError: null,
    }));
  };

  startNew = () => {
    this.setState((prev) => {
      const willShow = !prev.showHeaderCreator;
      return {
        showHeaderCreator: willShow,
        adding: willShow ? null : prev.adding,
        addError: null,
      };
    });
  };

  hasDuplicateTarget = (iref, location, dateFrom, dateTo, wDelivery) => {
    const { targets } = this.state;
    return (targets || []).some((t) =>
      (t.targetType === 0 || t.targetType === '0') &&
      String(t.location) === String(location) &&
      String(t.dateFrom) === String(dateFrom) &&
      String(t.dateTo) === String(dateTo) &&
      (!!t.wDelivery) === (!!wDelivery) &&
      (iref ? String(t.iref) !== String(iref) : true)
    );
  };

  saveAdd = async (addAnother = false) => {
    const { adding, client } = this.state;
    if (!adding) return;
    this.setState({ addError: null });
    if (!adding.location) {
      this.setState({ addError: 'Please choose a location.' });
      return;
    }
    if (this.hasDuplicateTarget(null, adding.location, adding.dateFrom, adding.dateTo, adding.wDelivery)) {
      this.setState({ addError: 'This location already has a target for the selected period.' });
      return;
    }

    this.setState({ submitBusy: true });

    const numericValue = adding.valueStr === '' || adding.valueStr === null || adding.valueStr === undefined
      ? 0
      : Number((adding.valueStr + '').replace(',', '.'));

    const payload = {
      iref: null,
      location: adding.location,
      targetType: 0,
      dateFrom: adding.dateFrom,
      dateTo: adding.dateTo,
      value: isNaN(numericValue) ? 0 : numericValue,
      wDelivery: !!adding.wDelivery,
      pCategory: null,
      pClass: null,
      pSubCategory: null,
    };

    try {
      const res = await (client.pushData ? client.pushData(API_URL_SALES_TARGETS, payload) : Promise.resolve(null));
      this.setState({ submitBusy: false });

      if (res === null) {
        this.setState({ addError: 'Could not save. Please check and try again.' });
        return;
      }

      await this.fetchTargets();

      if (addAnother) {
        this.setState((prev) => ({
          adding: {
            ...prev.adding,
            location: '',
            valueStr: '',
          },
          addError: null,
        }));
      } else {
        this.setState({ adding: null, addError: null });
      }
    } catch (e) {
      console.error('push error', e);
      let msg = 'Could not save. Please check and try again.';
      if (e && (e.message || e.detail)) msg = e.detail || e.message;
      this.setState({ submitBusy: false, addError: msg });
    }
  };

  cancelAdd = () => this.setState({ adding: null, addError: null });

  beginInlineEdit = (row) => {
    this.setState({ editingRow: { iref: row.iref, valueStr: row.value != null ? String(row.value) : '', saving: false, error: null } });
  };

  changeInlineValue = (valueStr) => {
    this.setState((prev) => ({ editingRow: prev.editingRow ? { ...prev.editingRow, valueStr, error: null } : null }));
  };

  cancelInline = () => this.setState({ editingRow: null });

  validateInline = () => {
    const er = this.state.editingRow;
    if (!er) return null;
    if (er.valueStr === '' || er.valueStr === null || er.valueStr === undefined) return 'Value is required.';
    const x = Number(String(er.valueStr).replace(',', '.'));
    if (Number.isNaN(x)) return 'Value must be numeric.';
    if (!Number.isFinite(x)) return 'Value is invalid.';
    if (x < 0) return 'Value cannot be negative.';
    return null;
  };

  saveInline = async (row) => {
    const err = this.validateInline();
    if (err) {
      this.setState(prev => ({ editingRow: { ...prev.editingRow, error: err } }));
      return;
    }
    const { editingRow } = this.state;
    if (!editingRow || editingRow.iref !== row.iref) return;
    this.setState({ editingRow: { ...editingRow, saving: true, error: null } });

    const numericValue = Number(String(editingRow.valueStr).replace(',', '.'));
    const url = API_URL_SALES_TARGETS.replace(/\/?$/, '/') + row.iref + '/update_value/';
    const res = await safeClientPush(this.state.client, url, { iref: row.iref, value: numericValue });

    if (res !== null) {
      await this.fetchTargets();
      this.setState({ saveNotice: 'Line updated.' });
    } else {
      this.setState({ editingRow: { ...editingRow, saving: false, error: 'Save failed. Please try again.' } });
    }
  };

  setBulkField = (label, key, value) => {
    this.setState(prev => ({
      bulkFields: { ...prev.bulkFields, [label]: { ...(prev.bulkFields[label]||{}), [key]: value } },
      bulkErrors: { ...prev.bulkErrors, [label]: { ...(prev.bulkErrors[label]||{}), range: undefined, conflict: undefined } }
    }));
  };

  toggleBulkMode = (label, on = undefined) => {
    this.setState(prev => {
      const v = on === undefined ? !prev.bulkMode[label] : on;
      const bulkMode = { ...prev.bulkMode, [label]: v };
      let bulkFields = { ...prev.bulkFields };
      let bulkErrors = { ...prev.bulkErrors };
      if (v && !bulkFields[label]) {
        const { from, to } = this.parsePeriodLabel(label);
        const firstRow = (this.groupedByPeriod()[label] || [])[0] || {};
        bulkFields[label] = { dateFrom: from, dateTo: to, wDelivery: !!firstRow.wDelivery };
        bulkErrors[label] = {};
      }
      if (!v) { delete bulkErrors[label]; }
      return { bulkMode, bulkFields, bulkErrors };
    });
  };

  toggleSelectAll = (label, checked) => {
    const rows = this.groupedByPeriod()[label] || [];
    const map = {};
    if (checked) for (const r of rows) map[r.iref] = true;
    this.setState(prev => ({ selected: { ...prev.selected, [label]: map } }));
  };

  toggleSelectOne = (label, iref, checked) => {
    this.setState(prev => ({ selected: { ...prev.selected, [label]: { ...(prev.selected[label]||{}), [iref]: checked } } }));
  };

  isValidDateStr = (s) => (/^\d{4}-\d{2}-\d{2}$/).test(String(s||''));
  cmpDate = (a, b) => String(a||'') <= String(b||'');

  validateBulk = (label) => {
    const fields = this.state.bulkFields[label] || {};
    const errs = {};
    if ('dateFrom' in fields && fields.dateFrom && !this.isValidDateStr(fields.dateFrom)) errs.dateFrom = 'Invalid date.';
    if ('dateTo' in fields && fields.dateTo && !this.isValidDateStr(fields.dateTo)) errs.dateTo = 'Invalid date.';
    if (fields.dateFrom && fields.dateTo && !this.cmpDate(fields.dateFrom, fields.dateTo)) errs.range = 'dateFrom must be ≤ dateTo.';

    const hasAny = ('dateFrom' in fields) || ('dateTo' in fields) || (typeof fields.wDelivery === 'boolean');
    if (!hasAny) errs.empty = 'Choose at least one field.';

    const selMap = this.state.selected[label] || {};
    if (!Object.values(selMap).some(Boolean)) errs.nosel = 'Select at least one line.';

    const rows = this.groupedByPeriod()[label] || [];
    const picked = rows.filter(r => !!selMap[r.iref]);
    const conflicts = [];
    for (const r of picked) {
      const newFrom = ('dateFrom' in fields) ? fields.dateFrom : r.dateFrom;
      const newTo = ('dateTo' in fields) ? fields.dateTo : r.dateTo;
      const newDel = (typeof fields.wDelivery === 'boolean') ? fields.wDelivery : !!r.wDelivery;
      if (this.hasDuplicateTarget(r.iref, r.location, newFrom, newTo, newDel)) {
        conflicts.push(r.iref);
      }
    }
    if (conflicts.length) errs.conflict = `Unique constraint would be violated for ${conflicts.length} line(s).`;

    return errs;
  };

  bulkApply = async (label) => {
    const errs = this.validateBulk(label);
    if (Object.keys(errs).length > 0) {
      this.setState(prev => ({ bulkErrors: { ...prev.bulkErrors, [label]: errs }, applyError: 'Fix errors before applying.' }));
      return;
    }
    this.setState({ applyError: null, saveNotice: null });

    const rows = this.groupedByPeriod()[label] || [];
    const selMap = this.state.selected[label] || {};
    const picked = rows.filter(r => !!selMap[r.iref]);
    const fields = this.state.bulkFields[label] || {};

    const payloadBase = {};
    if ('dateFrom' in fields) payloadBase.dateFrom = fields.dateFrom;
    if ('dateTo' in fields) payloadBase.dateTo = fields.dateTo;
    if (typeof fields.wDelivery === 'boolean') payloadBase.wDelivery = fields.wDelivery;

    let ok = 0, fail = 0;
    for (const r of picked) {
      const url = API_URL_SALES_TARGETS.replace(/\/?$/, '/') + r.iref + '/update_fields/';
      const payload = { iref: r.iref, ...payloadBase };
      const res = await safeClientPush(this.state.client, url, payload);
      if (res !== null) ok++; else fail++;
    }
    await this.fetchTargets();
    this.setExpanded(label, true);
    this.setState({ saveNotice: `Updated ${ok} line(s).${fail ? ' Failed: '+fail : ''}` });
  };

  renderHeaderCreator() {
    if (!this.state.showHeaderCreator) return null;
    return (
      <Box sx={{ p: 1, borderRadius: 2, border: '1px dashed #c5e1a5', mb: 1, bgcolor: '#f1f8e9' }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
          <Typography variant="subtitle2">New Target — choose Period & Delivery, then add locations</Typography>
          <Stack direction="row" spacing={1}>
            <Button size="small" onClick={() => this.setState({ showHeaderCreator: false })}>Hide panel</Button>
            <Button size="small" onClick={() => this.setState({ showHeaderCreator: false, adding: null, addError: null })}>Cancel</Button>
          </Stack>
        </Stack>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={6} sm={3} md={2.5}>
            <TextField
              label="dateFrom"
              type="date"
              fullWidth
              size="small"
              value={this.state.headerDateFrom}
              onChange={(e) => this.setState({ headerDateFrom: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6} sm={3} md={2.5}>
            <TextField
              label="dateTo"
              type="date"
              fullWidth
              size="small"
              value={this.state.headerDateTo}
              onChange={(e) => this.setState({ headerDateTo: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={7}>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
              <FormControlLabel
                sx={{ mr: 2 }}
                control={
                  <Checkbox
                    checked={!!this.state.headerWDelivery}
                    onChange={(e) => this.setState({ headerWDelivery: e.target.checked })}
                  />
                }
                label="With Delivery"
              />
              <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={this.startAddFromHeader}>
                Add location & value
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    );
  }

  renderAddEditor() {
    const { adding, submitBusy, addError } = this.state;
    if (!adding) return null;
    const bg = '#fffde7'; // light yellow for add

    return (
      <Box sx={{ p: 1, borderRadius: 2, border: '1px solid #eee', mb: 1, bgcolor: bg }}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={12} sm={4} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel id="loc-label">Location</InputLabel>
              <Select
                labelId="loc-label"
                label="Location"
                value={adding.location || ''}
                onChange={(e) => this.setState({ adding: { ...adding, location: e.target.value } })}
              >
                {this.state.locations.map((l) => (
                  <MenuItem key={l.iref ?? l.id ?? l.code} value={l.iref ?? l.id ?? l.code}>
                    {l.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={2} md={2}>
            <TextField
              fullWidth
              size="small"
              label="dateFrom"
              type="date"
              value={adding.dateFrom || ''}
              onChange={(e) => this.setState({ adding: { ...adding, dateFrom: e.target.value } })}
              InputLabelProps={{ shrink: true }}
              disabled={!!adding.lockPeriod}
            />
          </Grid>
          <Grid item xs={6} sm={2} md={2}>
            <TextField
              fullWidth
              size="small"
              label="dateTo"
              type="date"
              value={adding.dateTo || ''}
              onChange={(e) => this.setState({ adding: { ...adding, dateTo: e.target.value } })}
              InputLabelProps={{ shrink: true }}
              disabled={!!adding.lockPeriod}
            />
          </Grid>
          <Grid item xs={6} sm={2} md={2}>
            <TextField
              fullWidth
              size="small"
              type="text"
              inputMode="decimal"
              autoComplete="off"
              spellCheck={false}
              onKeyDown={(e) => { e.stopPropagation(); }}
              label="Value"
              value={adding.valueStr ?? ''}
              onChange={(e) => this.setState({ adding: { ...adding, valueStr: e.target.value } })}
              placeholder="0"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
              {/* wDelivery is locked when coming from period; use header panel to choose when creating a new period */}
              <Button size="small" startIcon={<SaveIcon />} variant="contained" disabled={submitBusy} onClick={() => this.saveAdd(false)}>
                Save
              </Button>
              <Button size="small" startIcon={<SaveIcon />} variant="outlined" disabled={submitBusy} onClick={() => this.saveAdd(true)}>
                Save & Add Another
              </Button>
              <Button size="small" startIcon={<CancelIcon />} variant="text" disabled={submitBusy} onClick={this.cancelAdd}>
                Cancel
              </Button>
            </Stack>
          </Grid>
        </Grid>
        {addError && (
          <Box sx={{ mt: 1 }}>
            <Alert severity="error" variant="outlined">{addError}</Alert>
          </Box>
        )}
      </Box>
    );
  }

  renderGroupHeaderControls(label) {
    const bulkOn = !!this.state.bulkMode[label];
    const bf = this.state.bulkFields[label] || {};
    const be = this.state.bulkErrors[label] || {};

    return (
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Add more locations to this fixed period
          </Typography>
          <Button
            size="small"
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => this.addNewForPeriod(label)}
          >
            Add location to this period
          </Button>
        </Stack>

        {/* Bulk Edit Controls */}
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <FormControlLabel
            control={<Checkbox checked={bulkOn} onChange={(e) => this.toggleBulkMode(label, e.target.checked)} />}
            label="Bulk edit this group"
          />
          {bulkOn && (
            <>
              <TextField
                size="small"
                label="dateFrom"
                type="date"
                value={bf.dateFrom || ''}
                onChange={(e) => this.setBulkField(label, 'dateFrom', e.target.value)}
                InputLabelProps={{ shrink: true }}
                error={!!be.dateFrom || !!be.range}
                helperText={be.dateFrom || (be.range ? be.range : '')}
              />
              <TextField
                size="small"
                label="dateTo"
                type="date"
                value={bf.dateTo || ''}
                onChange={(e) => this.setBulkField(label, 'dateTo', e.target.value)}
                InputLabelProps={{ shrink: true }}
                error={!!be.dateTo || !!be.range}
                helperText={be.dateTo || (be.range ? be.range : '')}
              />
              <FormControlLabel
                control={<Checkbox checked={!!bf.wDelivery} onChange={(e) => this.setBulkField(label, 'wDelivery', e.target.checked)} />}
                label="With Delivery"
              />
              <Button
                size="small"
                variant="contained"
                onClick={() => this.bulkApply(label)}
                startIcon={<SaveIcon />}
              >
                Apply to selected
              </Button>
            </>
          )}
        </Stack>
      </Box>
    );
  }

  renderList() {
    const groups = this.groupedByPeriod();

    if (this.state.loading) {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4 }}>
          <CircularProgress size={24} />
        </Box>
      );
    }

    const keys = Object.keys(groups);
    if (keys.length === 0) {
      return (
        <Box sx={{ py: 3, textAlign: 'center', color: 'text.secondary' }}>
          No sales targets found for selected period.
        </Box>
      );
    }

    const headerSx = { bgcolor: 'grey.100', color: 'text.primary', borderTopLeftRadius: 8, borderTopRightRadius: 8 };
    const bodySx = { bgcolor: 'background.paper' };

    return (
      <Box>
        {keys.sort().map((label) => {
          const rows = groups[label];
          const bulkOn = !!this.state.bulkMode[label];
          const selMap = this.state.selected[label] || {};
          const allChecked = rows.length > 0 && rows.every(r => selMap[r.iref]);
          const someChecked = !allChecked && Object.values(selMap).some(Boolean);
          const be = this.state.bulkErrors[label] || {};

          return (
            <Accordion
              key={label}
              expanded={!!this.state.expandedKeys[label]}
              onChange={(e, isExp) => this.setExpanded(label, isExp)}
              sx={{ mb: 1, boxShadow: 0, border: '1px solid #e0e0e0', borderRadius: 1 }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={headerSx}>
                <Typography variant="subtitle2">
                  {label} · {rows.length} item(s)
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={bodySx}>
                {this.renderGroupHeaderControls(label)}

                {(be.empty || be.nosel || be.conflict) && (
                  <Box sx={{ mb: 1 }}>
                    {be.empty && <Alert severity="error" variant="outlined">{be.empty}</Alert>}
                    {be.nosel && <Alert severity="error" variant="outlined">{be.nosel}</Alert>}
                    {be.conflict && <Alert severity="error" variant="outlined">{be.conflict}</Alert>}
                  </Box>
                )}

                {this.state.applyError && <Alert severity="error" sx={{ mb: 1 }}>{this.state.applyError}</Alert>}
                {this.state.saveNotice && <Alert severity="success" sx={{ mb: 1 }}>{this.state.saveNotice}</Alert>}

                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {bulkOn && (
                          <TableCell width={48}>
                            <Checkbox
                              checked={allChecked}
                              indeterminate={someChecked}
                              onChange={(e) => this.toggleSelectAll(label, e.target.checked)}
                            />
                          </TableCell>
                        )}
                        <TableCell><b>iref</b></TableCell>
                        <TableCell><b>Location</b></TableCell>
                        <TableCell align="right"><b>Value</b></TableCell>
                        <TableCell><b>Delivery</b></TableCell>
                        <TableCell align="right" width="220"><b>Actions</b></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row) => {
                        const isEditing = this.state.editingRow && this.state.editingRow.iref === row.iref;
                        return (
                          <TableRow key={row.iref} hover>
                            {bulkOn && (
                              <TableCell width={48}>
                                <Checkbox
                                  checked={!!selMap[row.iref]}
                                  onChange={(e) => this.toggleSelectOne(label, row.iref, e.target.checked)}
                                />
                              </TableCell>
                            )}
                            <TableCell>{row.iref}</TableCell>
                            <TableCell>{this.getLocationName(row.location)}</TableCell>
                            <TableCell align="right">
                              {isEditing ? (
                                <TextField
                                  size="small"
                                  type="text"
                                  inputMode="decimal"
                                  autoComplete="off"
                                  spellCheck={false}
                                  onKeyDown={(e) => { e.stopPropagation(); }}
                                  value={this.state.editingRow.valueStr}
                                  onChange={(e) => this.changeInlineValue(e.target.value)}
                                  sx={{ maxWidth: 160 }}
                                  error={!!this.state.editingRow.error}
                                  helperText={this.state.editingRow.error || ''}
                                />
                              ) : (
                                thousandsSeparator(parseInt(row.value || 0))
                              )}
                            </TableCell>
                            <TableCell>{row.wDelivery ? 'Yes' : 'No'}</TableCell>
                            <TableCell align="right">
                              {!isEditing ? (
                                <Button size="small" startIcon={<EditIcon />} onClick={() => this.beginInlineEdit(row)}>
                                  Edit
                                </Button>
                              ) : (
                                <Stack direction="row" spacing={1} justifyContent="flex-end">
                                  <Button
                                    size="small"
                                    startIcon={<SaveIcon />}
                                    variant="contained"
                                    onClick={() => this.saveInline(row)}
                                    disabled={this.state.editingRow.saving}
                                  >
                                    Save
                                  </Button>
                                  <Button
                                    size="small"
                                    startIcon={<CancelIcon />}
                                    variant="text"
                                    onClick={this.cancelInline}
                                    disabled={this.state.editingRow.saving}
                                  >
                                    Cancel
                                  </Button>
                                </Stack>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    );
  }

  render() {
    const { open, onClose } = this.props;
    const { filterFrom, filterTo, showHeaderCreator } = this.state;

    return (
      <Dialog
        open={open}
        onClose={onClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            width: {
              xs: 'calc(100% - 16px)',
              sm: '92vw',
              md: '78vw',
              lg: '68vw',
            },
            height: {
              xs: '92vh',
              sm: '90vh',
            },
            maxWidth: 'none',
            borderRadius: {
              xs: '14px',
              sm: '16px',
            },
            overflow: 'hidden',
          }
        }}
      >
        <AppBar sx={{ position: 'sticky' }} color="default" elevation={1}>
          <Toolbar variant="dense">
            <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close" size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="subtitle1" component="div">
              Sales Targets
            </Typography>
            <Button size="small" startIcon={<FileDownloadIcon />} onClick={this.onDownloadTargets} sx={{ mr: 1 }}>
              Download
            </Button>
            <Button size="small" startIcon={<AddIcon />} onClick={this.startNew}>
              {showHeaderCreator ? 'Hide New Target' : 'New Target'}
            </Button>
          </Toolbar>
        </AppBar>

        <Box sx={{ p: 1.5 }}>
          {/* Filters for list */}
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} md={3}>
              <TextField
                label="Filter From"
                type="date"
                fullWidth
                size="small"
                value={filterFrom}
                onChange={(e) => this.setState({ filterFrom: e.target.value })}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Filter To"
                type="date"
                fullWidth
                size="small"
                value={filterTo}
                onChange={(e) => this.setState({ filterTo: e.target.value })}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Button size="small" variant="contained" onClick={() => this.fetchTargets()}>
                Apply Filters
              </Button>
            </Grid>
          </Grid>

          <Divider sx={{ my: 1 }} />

          {/* Header-first creator (hidden by default) */}
          {this.renderHeaderCreator()}

          {/* Add editor (if any) */}
          {this.renderAddEditor()}

          {/* Grouped list with inline + bulk editing */}
          {this.renderList()}
        </Box>
      </Dialog>
    );
  }
}

class SalesTargetLocationList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client ( "none" ),
      saleslocation_list: [],
      page: 0,
      rowsPerPage: -1,
      order: 'asc',
      orderBy: null,
      dateFrom: d1Month,
      dateTo: today,
      sx_hidden: {display: 'none'},
      value: "1",
      filterData: {},
      locationGroups: [],
      locations: [],
      selectedLocationGroup: "all",
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.addDateFrom = this.addDateFrom.bind(this);
    this.addDateTo = this.addDateTo.bind(this);
    this.selectPeriod = this.selectPeriod.bind(this);

  }

  componentDidMount() {
    this.getData ( );
    this.loadLocationGroups();
    this.loadLocations();
  }

  getData ( ) {
    let queryData = { 
      "dateFrom": this.state.dateFrom,
      "dateTo": this.state.dateTo
  }
	  let data = BackofficeReportsApi.getSalesForecast(this.state.client, queryData);
    if ( data ) {
      this.setState ( { saleslocation_list: data });
    }
    this.setState ( { filterData: queryData } );
  }

  doSync ( ) {
    this.getData ( );
  }

  loadLocationGroups = () => {
    const data = BackofficeReportsApi.getLocationGroups(this.state.client);
    if (data && Array.isArray(data.locationsGroups)) {
      this.setState({ locationGroups: data.locationsGroups });
    } else if (Array.isArray(data)) {
      this.setState({ locationGroups: data });
    } else {
      this.setState({ locationGroups: [] });
    }
  };

  loadLocations = () => {
    const data = this.state.client.getData(
      Config.API_URL_LOCATIONS + 'list_locations/',
      { locationGroup_status: 1 }
    );
    if (data && Array.isArray(data.locations)) {
      this.setState({ locations: data.locations });
    } else if (Array.isArray(data)) {
      this.setState({ locations: data });
    }
  };

  filterByGroup = (rows) => {
    const { selectedLocationGroup, locations } = this.state;
    if (selectedLocationGroup === "all") return rows;

    const byName = {};
    const byDesc = {};
    locations.forEach((loc) => {
      if (loc.name) byName[loc.name.toLowerCase()] = loc;
      if (loc.description) byDesc[loc.description.toLowerCase()] = loc;
    });

    return rows.filter((r) => {
      const locKey = (r.location || "").toLowerCase();
      let loc = byName[locKey] || byDesc[locKey];
      if (!loc) return false;
      const groups = Array.isArray(loc.locationGroup) ? loc.locationGroup : [];
      return groups.includes(selectedLocationGroup);
    });
  };

  computeSubtotals = (rows) => {
    let salesMTD = 0;
    let targetTM = 0;
    let salesLM = 0;
    let targetLM = 0;
    let targetMTD = 0; // needed for % TM

    rows.forEach((r) => {
      salesMTD += parseFloat(r.salesMTD || 0);
      targetTM += parseFloat(r.targetTM || 0);
      salesLM += parseFloat(r.salesLM || 0);
      targetLM += parseFloat(r.targetLM || 0);
      targetMTD += parseFloat(r.targetMTD || 0); // some rows may have 0
    });

    const pctTM = targetMTD > 0 ? (salesMTD / targetMTD) * 100 : 0;
    const pctLM = targetLM > 0 ? (salesLM / targetLM) * 100 : 0;

    return { salesMTD, targetTM, salesLM, targetLM, pctTM, pctLM };
  };

  addDateFrom = (event) => {
    this.setState ({dateFrom: event.target.value});
  }

  addDateTo = (event) => {
    this.setState ({dateTo: event.target.value});
  }

  selectPeriod = (event) => {
    switch ( event.target.value ) {
      case "month": 
        this.setState ({sx_hidden: {display: 'none'}},  
        this.setState (
          {dateFrom: d1Month},  //beginning of the month
          function(){
          }
        ));
        this.setState (
          {dateTo: today},  //today
          function(){
            this.doSync ( );
          }
        ); 
        break;            
      case "last":
        this.setState ({sx_hidden: {display: 'none'}},
        this.setState (
          {dateFrom: d1LastMonth},  //beginning of last month
          function(){
          }
        ));
        this.setState (
          {dateTo: dzLastMonth},  //end of last month
          function(){
            this.doSync ( );
          }
        );
        break;            
      default:
        this.setState (
          {sx_hidden: {}},
          function(){
            this.doSync ( );
          }
        );
        // console.log(`No period selected.`);
    }
  }

  handleChangePage = (event, newPage) => {
    this.setState ({page: newPage});
  }
  
  handleChangeRowsPerPage = (event) => {
    this.setState ({rowsPerPage: +event.target.value});
    this.setState ({page: 0});
  }

  handleRequestSort = (property) => {
    const isAscending = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({ order: isAscending ? 'desc' : 'asc', orderBy: property, page: 0 });
  }

  onDownload = () => {
    const link = document.createElement("a");
    link.download = "salesTarget.csv";
    // console.log(this.state.saleslocation_list);
    // console.log(this.state.saleslocation_list.result);
    let csvData = objectToCsv(this.state.saleslocation_list.result);
    let csvHeader = "Sales Target";
    let csv = "\uFEFF" + csvHeader + "\n" + csvData;
    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    // console.log(link);
    link.click();
  };
  
  render() {
    let page = this.state.page;
    let rowsPerPage = this.state.rowsPerPage;
    let locationSalesData = [];
    let locationSalesList = [];
    if (this.state.saleslocation_list){
      if (this.state.saleslocation_list.result) {
        let counter = 0;
        Object.keys(this.state.saleslocation_list.result).forEach(key => {
          let fData = this.state.saleslocation_list.result[key];
          let myData = {'x': fData.location, 'y': (parseInt(fData.forecastTM/1000)+ "K")};
          let p = {
            id: counter+1,
            location: fData.location,
            forecastTM: fData.forecastTM,
            salesMTD: fData.salesMTD,
            salesLM: fData.salesLM,
            forecastMTD: fData.forecastMTD,
            targetTM: fData.targetTM,
            targetLM: fData.targetLM,
            targetMTD: fData.targetMTD
          }
          if (counter<10){
            locationSalesData.push ( myData );
          }
          counter += 1;
          locationSalesList.push ( p );
        });
      }
    }
    const filteredList = this.filterByGroup(locationSalesList);
    const subtotals = this.computeSubtotals(filteredList);
    const { order, orderBy } = this.state;
    const sortedFilteredList = orderBy
      ? [...filteredList].sort((a, b) => {
          const getValue = (row) => {
            if (orderBy === 'location') {
              return String(row.location || '').toLocaleLowerCase();
            }
            if (orderBy === 'pctTM') {
              const targetMTD = Number(row.targetMTD || 0);
              return targetMTD === 0 ? 0 : (Number(row.salesMTD || 0) / targetMTD) * 100;
            }
            if (orderBy === 'pctLM') {
              const targetLM = Number(row.targetLM || 0);
              return targetLM === 0 ? 0 : (Number(row.salesLM || 0) / targetLM) * 100;
            }
            return Number(row[orderBy] || 0);
          };
          const aValue = getValue(a);
          const bValue = getValue(b);
          if (aValue < bValue) return order === 'asc' ? -1 : 1;
          if (aValue > bValue) return order === 'asc' ? 1 : -1;
          return 0;
        })
      : filteredList;

    const sortLabel = (property, label) => (
      <TableSortLabel
        active={orderBy === property}
        direction={orderBy === property ? order : 'asc'}
        onClick={() => this.handleRequestSort(property)}
      >
        {label}
      </TableSortLabel>
    );

    const bodyCellSx = {
      py: {
        xs: 0.55,
        sm: 0.75,
        md: 0.8,
      },
      px: {
        xs: 0.35,
        sm: 0.65,
        md: 1,
      },
      whiteSpace: 'nowrap',
      color: '#111827',
      fontWeight: 450,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontVariantNumeric: 'tabular-nums',
    };

    return (
      <CardContent
        sx={{
          position: 'relative',
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
          boxSizing: 'border-box',
          height: {
            xs: 560,
            sm: 600,
            md: '100%',
            lg: '100%',
          },
          maxHeight: {
            xs: 560,
            sm: 600,
            md: '100%',
            lg: '100%',
          },
          minHeight: 0,
          p: '0 !important',
          borderRadius: {
            xs: '14px',
            sm: '16px',
          },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          bgcolor: '#fff',
        }}
      >
        <Box
          sx={{
            px: {
              xs: 0.75,
              sm: 1,
            },
            py: {
              xs: 0.65,
              sm: 0.85,
            },
            flexShrink: 0,
            borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
            bgcolor: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: {
                xs: 'stretch',
                sm: 'center',
              },
              justifyContent: 'space-between',
              gap: {
                xs: 0.75,
                sm: 1,
              },
              flexDirection: {
                xs: 'column',
                sm: 'row',
              },
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  color: '#1a237e',
                  fontWeight: 800,
                  fontSize: {
                    xs: '0.9rem',
                    sm: '1rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Target Sales
              </Typography>

              <Typography
                sx={{
                  mt: 0.15,
                  color: '#64748b',
                  fontWeight: 600,
                  fontSize: {
                    xs: '0.72rem',
                    sm: '0.78rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Sales target progress by location
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: {
                  xs: 'space-between',
                  sm: 'flex-end',
                },
                gap: 0.75,
                flexWrap: 'wrap',
              }}
            >
              <FormControl
                size="small"
                sx={{
                  minWidth: {
                    xs: 180,
                    sm: 200,
                  },
                  maxWidth: {
                    xs: 'calc(100% - 88px)',
                    sm: 240,
                  },
                  '& .MuiInputBase-root': {
                    height: 36,
                    borderRadius: '12px',
                    fontSize: {
                      xs: '0.82rem',
                      sm: '0.88rem',
                    },
                    bgcolor: '#fff',
                  },
                }}
              >
                <Select
                  labelId="lg-label"
                  value={this.state.selectedLocationGroup}
                  onChange={(e) => this.setState({ selectedLocationGroup: e.target.value, page: 0 })}
                  displayEmpty
                  sx={{
                    '& .MuiSelect-select': {
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  }}
                >
                  <MenuItem value="all">All groups</MenuItem>
                  {this.state.locationGroups.map((lg) => (
                    <MenuItem key={lg.iref} value={lg.iref}>
                      {lg.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Tooltip title="Download CSV">
                <Button
                  size="small"
                  onClick={this.onDownload}
                  variant="contained"
                  sx={{
                    minWidth: 36,
                    width: 36,
                    height: 36,
                    p: 0,
                    flexShrink: 0,
                    borderRadius: '12px',
                    color: '#1a237e',
                    bgcolor: 'rgba(26, 35, 126, 0.08)',
                    boxShadow: 'none',
                    border: '1px solid rgba(26, 35, 126, 0.12)',
                    '&:hover': {
                      bgcolor: 'rgba(26, 35, 126, 0.12)',
                      boxShadow: 'none',
                    },
                  }}
                >
                  <FileDownloadIcon fontSize="small" />
                </Button>
              </Tooltip>

              <Tooltip title="Manage sales targets">
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => this.setState({ targetsOpen: true })}
                  startIcon={<AddIcon fontSize="small" />}
                  sx={{
                    height: 36,
                    borderRadius: '12px',
                    boxShadow: 'none',
                    textTransform: 'none',
                    fontWeight: 750,
                    px: {
                      xs: 1,
                      sm: 1.2,
                    },
                    '&:hover': {
                      boxShadow: 'none',
                    },
                    '& .MuiButton-startIcon': {
                      mr: {
                        xs: 0,
                        sm: 0.5,
                      },
                    },
                  }}
                >
                  <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                    Target
                  </Box>
                </Button>
              </Tooltip>
            </Box>
          </Box>
        </Box>

        <TableContainer
          sx={{
            flex: 1,
            minHeight: 0,
            minWidth: 0,
            width: '100%',
            maxWidth: '100%',
            overflowX: {
              xs: 'auto',
              sm: 'auto',
              md: 'hidden',
            },
            overflowY: 'auto',
            borderTop: '1px solid rgba(15, 23, 42, 0.06)',
            '&::-webkit-scrollbar': {
              height: 8,
              width: 8,
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(15, 23, 42, 0.18)',
              borderRadius: 999,
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: 'rgba(15, 23, 42, 0.04)',
            },
          }}
        >
          <Table
            stickyHeader
            size="small"
            aria-label="target sales table"
            sx={{
              minWidth: {
                xs: 760,
                sm: 900,
                md: '100%',
              },
              width: '100%',
              maxWidth: '100%',
              tableLayout: {
                xs: 'fixed',
                md: 'auto'
              },
              '& .MuiTableCell-root': {
                borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
                fontSize: {
                  xs: '0.78rem',
                  sm: '0.88rem',
                  md: '0.86rem',
                  lg: '0.88rem',
                },
              },
              '& .MuiTableRow-hover:hover': {
                backgroundColor: 'rgba(26, 35, 126, 0.035)',
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    py: { xs: 0.5, sm: 0.7, md: 0.85 },
                    px: { xs: 0.35, sm: 0.65, md: 1 },
                    bgcolor: '#f8fafc',
                    color: '#1a237e',
                    fontWeight: 650,
                    lineHeight: 1.15,
                    whiteSpace: 'normal',
                    overflow: 'visible',
                    textOverflow: 'clip',
                    position: 'sticky',
                    left: 0,
                    zIndex: 4,
                    width: {
                      xs: 120,
                      sm: 170,
                      md: '24%',
                    },
                  }}
                >
                  {sortLabel('location', 'Location')}
                </TableCell>

                {[
                  ['Sales MTD', 'salesMTD', { xs: 88, sm: 105, md: '13%' }],
                  ['Target TM', 'targetTM', { xs: 88, sm: 105, md: '13%' }],
                  ['% TM', 'pctTM', { xs: 62, sm: 75, md: '10%' }],
                  ['Sales LM', 'salesLM', { xs: 88, sm: 105, md: '13%' }],
                  ['Target LM', 'targetLM', { xs: 88, sm: 105, md: '13%' }],
                  ['% LM', 'pctLM', { xs: 62, sm: 75, md: '10%' }],
                ].map(([label, property, width]) => (
                  <TableCell
                    key={label}
                    align="right"
                    sx={{
                      py: { xs: 0.5, sm: 0.7, md: 0.85 },
                      px: { xs: 0.35, sm: 0.65, md: 1 },
                      bgcolor: '#f8fafc',
                      color: '#1a237e',
                      fontWeight: 650,
                      lineHeight: 1.15,
                      whiteSpace: 'normal',
                      overflow: 'visible',
                      textOverflow: 'clip',
                      width,
                    }}
                  >
                    {sortLabel(property, label)}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? sortedFilteredList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : sortedFilteredList
              ).map((location) => {
                return (
                  <TableRow hover key={location.id} tabIndex={-1}>
                    <TableCell
                      sx={{
                        py: { xs: 0.55, sm: 0.75, md: 0.8 },
                        px: { xs: 0.35, sm: 0.65, md: 1 },
                        position: 'sticky',
                        left: 0,
                        zIndex: 2,
                        bgcolor: '#fff',
                        whiteSpace: 'nowrap',
                        color: '#111827',
                        fontWeight: 550,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: {
                          xs: 120,
                          sm: 170,
                          md: '24%',
                        },
                      }}
                    >
                      {location.location}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {thousandsSeparator(parseInt(location.salesMTD))}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {thousandsSeparator(parseInt(location.targetTM))}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {location.targetMTD === 0 ? 0 + "%" : parseInt((location.salesMTD / location.targetMTD) * 100) + "%"}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {thousandsSeparator(parseInt(location.salesLM))}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {thousandsSeparator(parseInt(location.targetLM))}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {location.targetLM === 0 ? 0 + "%" : parseInt((location.salesLM / location.targetLM) * 100) + "%"}
                    </TableCell>
                  </TableRow>
                );
              })}

              {this.state.selectedLocationGroup !== "all" && (
                <TableRow
                  sx={{
                    '& .MuiTableCell-root': {
                      bgcolor: 'rgba(26, 35, 126, 0.055)',
                      color: '#111827',
                      fontWeight: 900,
                      borderTop: '1px solid rgba(26, 35, 126, 0.12)',
                    },
                    '& .MuiTableCell-root:first-of-type': {
                      color: '#1a237e',
                    },
                  }}
                >
                  <TableCell
                    sx={{
                      py: { xs: 0.6, sm: 0.8 },
                      px: { xs: 0.5, sm: 1 },
                      position: 'sticky',
                      left: 0,
                      zIndex: 2,
                      bgcolor: 'rgba(26, 35, 126, 0.055)',
                      fontWeight: 900,
                    }}
                  >
                    Subtotal
                  </TableCell>

                  <TableCell align="right" sx={bodyCellSx}>
                    {thousandsSeparator(parseInt(subtotals.salesMTD))}
                  </TableCell>

                  <TableCell align="right" sx={bodyCellSx}>
                    {thousandsSeparator(parseInt(subtotals.targetTM))}
                  </TableCell>

                  <TableCell align="right" sx={bodyCellSx}>
                    {subtotals.pctTM.toFixed(1)}%
                  </TableCell>

                  <TableCell align="right" sx={bodyCellSx}>
                    {thousandsSeparator(parseInt(subtotals.salesLM))}
                  </TableCell>

                  <TableCell align="right" sx={bodyCellSx}>
                    {thousandsSeparator(parseInt(subtotals.targetLM))}
                  </TableCell>

                  <TableCell align="right" sx={bodyCellSx}>
                    {subtotals.pctLM.toFixed(1)}%
                  </TableCell>
                </TableRow>
              )}

              {filteredList.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Box
                      sx={{
                        py: 4,
                        color: 'text.secondary',
                        fontSize: {
                          xs: '0.86rem',
                          sm: '0.92rem',
                        },
                      }}
                    >
                      No data
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, { value: -1, label: 'All' }]}
          labelRowsPerPage="Rows:"
          component="div"
          count={filteredList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          sx={{
            flexShrink: 0,
            borderTop: '1px solid rgba(15, 23, 42, 0.06)',
            bgcolor: '#fff',
            minHeight: {
              xs: 44,
              sm: 52,
            },
            '& .MuiTablePagination-toolbar': {
              minHeight: {
                xs: 44,
                sm: 52,
              },
              px: {
                xs: 0.5,
                sm: 1,
              },
              flexWrap: {
                xs: 'wrap',
                sm: 'nowrap',
              },
              gap: {
                xs: 0.25,
                sm: 0.5,
              },
            },
            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
              fontSize: {
                xs: '0.88rem',
                sm: '0.92rem',
                md: '1rem',
              },
              m: 0,
            },
            '& .MuiTablePagination-actions': {
              ml: {
                xs: 0,
                sm: 1,
              },
            },
          }}
        />

        {this.state.targetsOpen && (
          <SalesTargetsModal
            open={this.state.targetsOpen}
            onClose={() => this.setState({ targetsOpen: false })}
            dateFrom={this.state.dateFrom}
            dateTo={this.state.dateTo}
          />
        )}
      </CardContent>
    );

  }
}

export default SalesTargetLocationList;
